<template lang="pug">
    checkbox.justify-center(@value="onChange" :checked="isApproved" :disabled="!hasProfile")
        .ml-2.text-xs подтвержден
</template>

<script>
import Checkbox from '@/components/common/checkbox';
import { RecipientsNameSpace, RecipientsActionTypes } from '@/store/recipients/types';

export default {
    name: "ApprovedCheckbox",
    components: {
        'checkbox': Checkbox,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        hasProfile() {
            return Boolean(this.item.profile);
        },
        isApproved() {
            const profile = this.item.profile;
            return Boolean(profile && typeof profile === 'object' && profile.approved);
        },
    },
    methods: {
        async onChange(value) {
            if (!this.hasProfile) {
                return;
            }
            await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.EditRecipient}`, {
                id: this.item._id,
                value: { approved: value },
            });
        },
    },
}
</script>
